"use client";

import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/navigation";
import type { PropsWithChildren } from "react";
import { RouterProvider } from "react-aria-components";
declare module "react-aria-components" {
  interface RouterConfig {
    routerOptions: NonNullable<Parameters<ReturnType<typeof useRouter>["push"]>[1]>;
  }
}
export const RouteProvider = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== children || $[1] !== router.push) {
    t1 = <RouterProvider navigate={router.push}>{children}</RouterProvider>;
    $[0] = children;
    $[1] = router.push;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};